<template>
  <div>
    <a-list item-layout="vertical" size="large" :data-source="listData" class="onboarding-list mb-120">
      <a-list-item slot="renderItem" key="item.title" slot-scope="item, index">
        <img
          slot="extra"
          alt="illustration"
          :src="item.image"
          class="onboarding-item-img clickable-img"
          @click="handlePreview(item.image)"
        />
        <a-list-item-meta :description="item.description">
          <div slot="title" class="font-web onboarding-item-title-wrapper">
            <span class="onboarding-item-title">{{ item.title }}</span>
          </div>
        </a-list-item-meta>
        <div class="onboarding-item-content">
          <div class="content-section mb-10">
            <h4 class="font-web section-label">รายละเอียด / Description</h4>
            <p class="font-web mt-0 mb-0">{{ item.content }}</p>
          </div>
        </div>
        <template slot="actions"></template>
      </a-list-item>
    </a-list>

    <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel" width="80%">
      <img alt="preview" style="width: 100%" :src="previewImage" />
    </a-modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      previewVisible: false,
      previewImage: '',
      listData: [
        {
          title: 'Performance Management Guideline for Division Chairs',
          description: '',
          content: 'An overview of the annual performance management process for Division Chairs, including PA setting, evaluation, and key requirements.',
          image: '/images/hri_dashboard/FlowchartonPerformanceAppraisalManagementforChairs.png'
        }
      ]
    };
  },
  methods: {
    handlePreview(image) {
      this.previewImage = image;
      this.previewVisible = true;
    },
    handleCancel() {
      this.previewVisible = false;
    }
  }
};
</script>

<style scoped>
.onboarding-list {
  padding: 0 20px;
  margin-bottom: 200px;
}
.onboarding-item-title {
  font-size: 20px !important;
  font-weight: 800 !important;
  color: #1a1a2e !important;
  transition: color 0.3s ease;
}
.onboarding-item-title:hover {
  color: #4285F4 !important;
}
.onboarding-item-content {
  color: #595959;
  font-size: 14px;
  line-height: 1.6;
}
.section-label {
  font-size: 13px;
  font-weight: 700;
  color: #8c8c8c;
  text-transform: uppercase;
  margin-bottom: 5px;
  letter-spacing: 0.5px;
}
.onboarding-item-title-wrapper {
  margin-bottom: 4px;
}
.onboarding-item-img {
  width: 280px;
  border-radius: 12px;
  box-shadow: 0 4px 15px rgba(0,0,0,0.08);
  object-fit: cover;
  transition: transform 0.3s ease;
}
.clickable-img {
  cursor: pointer;
}
@media (max-width: 768px) {
  .onboarding-list {
    padding: 0 10px;
  }
  .onboarding-item-title {
    font-size: 18px !important;
  }
  .onboarding-item-img {
    width: 100% !important;
    max-width: 320px;
    margin-top: 10px;
  }
  ::v-deep .ant-list-item-extra {
    margin-left: 0 !important;
    display: flex;
    justify-content: center;
  }
}
.mt-15 {
  margin-top: 15px;
}
.onboarding-item-img:hover {
  transform: scale(1.02);
}

/* Custom layout adjustments for Ant Design list-item actions */
::v-deep .ant-list-item-action {
  margin-top: 20px;
}
</style>
